/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_403Inputs */

const en_api_error_403 = /** @type {(inputs: Api_Error_403Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to perform this action.`)
};

const pt_br2_api_error_403 = /** @type {(inputs: Api_Error_403Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem permissão para realizar esta ação.`)
};

/**
* | output |
* | --- |
* | "You do not have permission to perform this action." |
*
* @param {Api_Error_403Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_403 = /** @type {((inputs?: Api_Error_403Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_403Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_403(inputs)
	return pt_br2_api_error_403(inputs)
});